import ReactDOM from 'react-dom';


// The first argument (child) can be any child displayable by React, such as an element, a string or a fragment. The second argument (container) is a DOM element.
function Portal(props) {
    return ReactDOM.createPortal(props.children, document.body);
}

export default Portal;